import React from "react"
import { Target, getBorderColor, getTextColor } from "../../../utils"

type Props = {
  items: { title: string; descriptions: string[] }[]
  target: Target
}

const Feature: React.VFC<Props> = ({ items, target }) => {
  return (
    <div className="grid-cols-2 gap-8 mt-12 space-y-8 md:mt-20 md:space-y-0 md:grid">
      {items.map((item, index) => {
        return (
          <div
            key={item.title}
            className={`p-5 text-center border-4 border-opacity-20 md:p-8 rounded-3xl ${getBorderColor(
              target
            )}`}
          >
            <div className={`text-3xl font-kiwiMaru ${getTextColor(target)}`}>
              {index + 1}
            </div>
            <div className="mt-8 text-lg font-kiwiMaru text-left">{item.title}</div>
            <div className="mt-5 space-y-2 text-left">
              {item.descriptions.map((item, index) => {
                return (
                  <div key={`desc-${index}`}>
                    <span className="text-gray-300">● </span>
                    {item}
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Feature
